/**
 * Always dd/mm/yyyy here, regardless of the general Settings date format.
 * This tab produces the figures for a government VAT return, and that
 * shouldn't silently change if someone later changes the app's display
 * preference for everyday use elsewhere. Works directly on the stored
 * "YYYY-MM-DD" string — no Date-object parsing, so no timezone to get wrong.
 */
export function formatVatDate(iso: string): string {
  const [y, m, d] = iso.split('-')
  return `${d}/${m}/${y}`
}
